// removed by extract-text-webpack-plugin
module.exports = {"paginationBlock":"_2OouIFBFLJpOUqV6s_2JmM","navigateBtn":"_2rRhVwl32zNCJ5kSdcMPOy","inputSection":"_2cmUeLIkQnjZNDIMWfvy3C","showRows":"_26oR7mQ8dpp2Tsh70ITR7s","inputWrapper":"_2Fx2Q0gLLA3h_HpXsBK497","forwardBtn":"x_fCfQTYwayQpgp5yGUXo","backBtn":"kdv0cTplxFcllhhE_3JUw","publishDate":"_3SuevZkLX2GRNL7zynlR5R","questionsInfoContainer":"_1gdY9F-V0UZeEe1TgqHtny","questionsCount":"_1UwPsH5Dz3eDUH38ckviKV","buyMoreButton":"vr4HbA4grYWLL2ARFuDkj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/Pagination/PaginationStaff.scss
// module id = 1835
// module chunks = 0